import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import LockIcon from '@mui/icons-material/Lock';
import Tooltip from '@mui/material/Tooltip';
import UpgradeSymbols from './UpgradeSymbols';
import { NumberChip, GreaterThanIcon } from './BookingIcons';

function BookingCardIcons({
  comment,
  upgrades,
  manualUpgrades,
  participantCount,
  capacityBlockedCount,
  slotMode,
  color,
  onGreaterThanClick,
}) {
  // A capacity override lets a booking block more places than it has guests.
  // Without a marker the card looks harmless while the slot is effectively full.
  const blocked = Number(capacityBlockedCount);
  const showOverride =
    Number.isFinite(blocked) && blocked > Number(participantCount || 0);

  return (
    <Stack
      direction='row'
      spacing={1}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {comment && (
          <Tooltip title={comment}>
            {/* Theme-aware color keeps the note icon visible on the light card
                surface in light mode (white-on-white was invisible there). */}
            <TextSnippetIcon sx={{ color: 'text.secondary' }} />
          </Tooltip>
        )}
      </Box>
      <UpgradeSymbols upgrades={upgrades} manualUpgrades={manualUpgrades} />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '2px' }}>
        <NumberChip number={participantCount} size='small' color={color} />
        {showOverride && (
          <Tooltip
            title={`Kapazitätsübersteuerung: blockiert ${blocked} Plätze (${participantCount} Teilnehmer)`}
          >
            <Box
              component='span'
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '1px',
                fontSize: '0.75rem',
                fontWeight: 700,
                color: 'text.secondary',
              }}
            >
              <LockIcon sx={{ fontSize: '0.9rem' }} />
              {blocked}
            </Box>
          </Tooltip>
        )}
      </Box>
      {slotMode && (
        <Box
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onGreaterThanClick(e);
          }}
          onMouseDown={e => {
            // Prevent parent card's mouse down handler from initiating a drag or click
            e.stopPropagation();
          }}
          onTouchStart={e => {
            // Prevent parent card's touch start handler from initiating a drag or click
            e.stopPropagation();
          }}
          onTouchEnd={e => {
            e.preventDefault();
            e.stopPropagation();
            onGreaterThanClick(e);
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <GreaterThanIcon color={color} />
        </Box>
      )}
    </Stack>
  );
}

export default BookingCardIcons;
